// SF2 — the term across recent windows. A window nobody collected is a gap,
// not a zero: the volume did not fall, we did not ask.
import React, { useEffect, useState } from 'react';
import s from '../SearchTerms.module.css';
import { num, pct } from '../format';
import { getTermTrend } from '../api';

export default function Trend({ token, term, period, startDate }) {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    let live = true;
    setData(null);
    getTermTrend(token, term, { period, start_date: startDate })
      .then((r) => live && setData(r))
      .catch((e) => live && setError(e.message));
    return () => { live = false; };
  }, [token, term, period, startDate]);

  if (error) return null;
  if (!data) return <div className={s.hint}>Loading trend…</div>;

  const live = data.points.filter((p) => p.present);
  const peak = Math.max(...live.map((p) => p.volume), 1);
  const dir = data.summary.direction;

  return (
    <div className={s.section}>
      <div className={s.sectionTitle}>
        Search volume · last {data.points.length} {period.toLowerCase()}s
      </div>
      {live.length < 2 ? (
        <p className={s.hint}>
          Only {live.length} of these {period.toLowerCase()}s has been collected, so there is
          no trend yet. Collect an earlier window to compare against.
        </p>
      ) : (
        <p className={s.hint}>
          {num(data.summary.first)} → {num(data.summary.last)}{' '}
          <span className={dir === 'up' ? s.up : dir === 'down' ? s.down : s.flat}>
            {dir === 'up' ? '▲' : dir === 'down' ? '▼' : '—'}{' '}
            {data.summary.change == null ? '' : pct(Math.abs(data.summary.change), 0)}
          </span>
        </p>
      )}

      <div className={s.tableWrap}>
        <table className={s.table}>
          <thead>
            <tr>
              <th>Window</th>
              <th className={s.numeric}>Volume</th>
              <th className={s.numeric}>Your clicks</th>
              <th className={s.numeric}>Impr. share</th>
              <th />
            </tr>
          </thead>
          <tbody>
            {data.points.map((p) => (
              <tr key={p.start_date}>
                <td>{p.start_date}</td>
                {p.present ? (
                  <>
                    <td className={s.numeric}>{num(p.volume)}</td>
                    <td className={s.numeric}>{num(p.clicks)}</td>
                    <td className={s.numeric}>{pct(p.impression_share)}</td>
                    <td style={{ width: '38%' }}>
                      <span className={s.barTrack} style={{ width: '100%', display: 'block' }}>
                        <span className={s.barFill}
                              style={{ width: `${Math.round((p.volume / peak) * 100)}%` }} />
                      </span>
                    </td>
                  </>
                ) : (
                  <td colSpan={4} className={s.muted}>
                    {p.collected ? 'collected — the term did not appear' : 'not collected'}
                  </td>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
